// make these types of errors look the same, so that NR groups them as the same error
function makeChunkLoadErrorsLookTheSame(error) {
  error.message = 'Chunk load error';
}

export const logError = (error: Error): void => {
  if (! window.newrelic) return;
  if (error?.name === 'ChunkLoadError') {
    makeChunkLoadErrorsLookTheSame(error);

    window.newrelic.noticeError(error, { originalMessage: error.message });
  } else {
    window.newrelic.noticeError(error);
  }
};

export default { logError };
